import React from 'react';
import { Content, Pane, Button, Flex, Text } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { ErrorGeneric as ErrorGenericPlugin } from '@leverege/molten/imagine';
import S from './VehicleExists.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  component: ErrorGenericClass
} = ErrorGenericPlugin;
export default class VehicleExists extends ErrorGenericClass {
  contactSupport = () => {
    const {
      supportTemplate,
      onClose,
      initialData
    } = this.props;
    const messageText = supportTemplate.replace('$VIN', initialData?.data?.vin || 'Unknown');
    window?.Intercom('showNewMessage', messageText);
    onClose?.();
  };
  renderBody() {
    const {
      variant,
      headerVariant,
      bodyVariant,
      footerVariant,
      titleVariant,
      errorTitle,
      errorBody,
      onClose,
      blueprint
    } = this.props;
    const {
      breakpoint
    } = this.state;
    const vnt = variant || (breakpoint === 'small' ? 'mobileItemForm' : 'itemForm');
    const headerVnt = headerVariant || (breakpoint === 'small' ? 'mobileItemFormHeader' : 'itemFormHeader');
    const bodyVnt = bodyVariant || (breakpoint === 'small' ? 'mobileItemFormBody' : 'itemFormBody');
    const footerVnt = footerVariant || (breakpoint === 'small' ? 'mobileItemFormFooter' : 'itemFormFooter');
    const title = 'Create Vehicle';
    const titleIcon = blueprint.getIcon('createDialogIcon') || blueprint.getIcon('screenIcon');
    return /*#__PURE__*/_jsx(Pane, {
      variant: vnt,
      children: /*#__PURE__*/_jsxs(Content, {
        relative: breakpoint === 'big',
        children: [/*#__PURE__*/_jsx(Content.Header, {
          variant: `${headerVnt}|formHeader`,
          children: /*#__PURE__*/_jsx(TitleBar, {
            variant: titleVariant,
            title: title,
            icon: titleIcon
          })
        }), /*#__PURE__*/_jsx(Content.Area, {
          variant: `${bodyVnt}|formBody`,
          className: S.form,
          children: /*#__PURE__*/_jsxs(Flex, {
            variant: "colL",
            children: [/*#__PURE__*/_jsx("img", {
              className: S.locatorError,
              src: "https://recovr-ui-assets.storage.googleapis.com/vehicle-error.png",
              alt: "Locator warning",
              height: 136,
              width: 136
            }), /*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: errorTitle
            }), /*#__PURE__*/_jsx(Text, {
              children: errorBody
            })]
          })
        }), /*#__PURE__*/_jsxs(Content.Footer, {
          variant: `${footerVnt}|formButtons`,
          layout: "flex:rowMEnd",
          children: [/*#__PURE__*/_jsx(Button, {
            variant: "secondary",
            onClick: onClose,
            children: "Cancel"
          }), /*#__PURE__*/_jsx(Button, {
            variant: "primary",
            onClick: this.contactSupport,
            children: "Contact Customer Support"
          })]
        })]
      })
    });
  }
}